
import React, {Component} from 'react';
import {CardHeader, CardText} from 'material-ui/Card';
import logo from '../components/logo.png';
import LinearProgress from 'material-ui/LinearProgress'
import Avatar from 'material-ui/Avatar';
import Chip from 'material-ui/Chip';

class GameItem extends Component {
    render() {
        var genres = this.props.data.genre.split(',');
        var genrelist = genres.map(function (genre, index) {
            return (
                <Chip key={index} style={{margin: '5% 0 5% 0'}}><Avatar size={32}>{genres[index][0]}</Avatar>{genre}</Chip>
            );
        }, this);

        return (
            <div className="box" >
                <div class="flex-container">
            
               <div className="title">

                <CardHeader 
                    title={this.props.data.title}
                    
                    subtitle={this.props.data.platform}
                    actAsExpander={false}
                    showExpandableButton={false}
                />
                </div>
                <img src={logo} className='logo'/>
                <div className="rating">

                <CardText >

                    <strong>Rating Score: {this.props.data.score} / 10</strong>



                    <div className='progress'>
                    <LinearProgress id="progress" mode="determinate" value={this.props.data.score * 10}/>
                    </div>  

                    
                    <div className='genre' >
             
                        {this.props.data.genre !== '' && genrelist }
                       
                        {this.props.data.editors_choice === 'Y'&&


                        <Chip style={{margin: '5% 0 5% 0',  }}  className='ec' >    
                        <Avatar size={32} backgroundColor={'#00BCD4'}  >E</Avatar>Editors Choice</Chip>}
                    </div>

                    
                </CardText>
                </div>

            
</div>























            </div>
        );
    }
}

export default GameItem;


// WEBPACK FOOTER //
// ./src/components/GameItem.js